<template>
  <div v-if="latestReplies.length > 0" class="dropdown_menu">
    <h3
      class="ml_15 pb_15 pt_15"
      style="border-bottom: 1px solid #ddd; margin-right: 15px"
    >
      Notifications
    </h3>
    <ul>
      <li
        class="d-block cursor_pointer"
        :class="{ background: !latestReplies.read_at }"
        v-for="(latestReplies, index) in latestReplies"
        :key="'request_' + index"
      >
        <a role="button" @click="markAsRead(latestReplies)"
          >{{ latestReplies?.ticket?.ticket_number }} :
          {{ latestReplies?.ticket?.subject }}</a
        >
        <p class="ml_15 mb_0">
          {{ latestReplies?.email_created_by_customer?.name }} :
          {{ latestReplies.formatted_created_at }}
        </p>
      </li>
    </ul>
    <!--                      <router-link :to="{name: 'support-requests'}" class="btn btn_sm btn_black has_border_radius">View all</router-link>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store';

export default {
  name: 'HeaderNotificationsComponent',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      latestReplies: 'notification/latestReplies',
    }),
  },
  watch: {
    $route() {
      window.$('.dropdown_menu').removeClass('open');
    },
  },
  methods: {
    markAsRead(latestReplies) {
      this.axios
        .post(`/mark-as-read-latest-replies/${latestReplies.id}`)
        .then(() => {
          store.dispatch('notification/loadLatestReplies');
          this.$router.push(`/ticket/${latestReplies?.ticket?.ticket_number}`);
        });
    },
  },
};
</script>

<style scoped>
.dropdown_menu {
  min-width: 250px;
}
.background {
  background: #f6f6f6;
  margin-bottom: 5px;
  padding: 5px 0;
}
</style>
